<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M43.56 22.94l-14-14a1.5 1.5 0 00-2.12 2.12L38.88 22.5H5.5a1.5 1.5 0 000 3h33.38L27.44 36.94a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12 0l14-14a1.49 1.49 0 000-2.12z"/></svg>